
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __appWithI18n from 'next-translate/appWithI18n'
// @ts-ignore
    
import { NextComponentType } from "next"
import { AppContext, AppInitialProps, AppProps } from "next/app"
import { ErrorProps } from "next/error"
import Head from "next/head"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"

import { dataLayerPush } from "@app/shared/utils/tracking/dataLayer"

import "@casavo/habitat/style.css"
import "@shared/styles/css/carousel.css"
import "@shared/styles/css/chat-widget.css"
import "@shared/styles/css/style.css"
import "@shared/styles/css/variables.css"
import "tippy.js/dist/tippy.css"

export type CustomAppComponent = NextComponentType<
  AppContext,
  AppInitialProps,
  AppProps & { err: ErrorProps }
>

declare global {
  interface IubendaAPI {
    isConsentGiven: () => boolean
    getPreferences: () => null | {
      id: number
      timestamp: string
      purposes: {
        [key: string]: boolean
      }
    }
  }

  interface Window {
    _iub: {
      cs?: {
        api?: IubendaAPI
      }
    }
    dataLayer: any[]
  }
}

const CustomApp: CustomAppComponent = ({ Component, err, pageProps }) => {
  const router = useRouter()
  const [consentExpressed, setConsentExpressed] = useState(false)

  useEffect(() => {
    console.log("[DBG] Initializing consent check")

    // Check initial consent status
    if (typeof window !== "undefined" && window._iub?.cs?.api) {
      console.log("[DBG] Iubenda API available, checking preferences")
      const preferences = window._iub.cs.api.getPreferences()
      console.log("[DBG] Current preferences:", preferences)

      const hasExpressedPreferences =
        preferences !== null && "timestamp" in preferences && "purposes" in preferences

      console.log("[DBG] Has expressed preferences:", hasExpressedPreferences)

      if (hasExpressedPreferences) {
        console.log("[DBG] Setting consentExpressed to true (from stored preferences)")
        setConsentExpressed(true)
        return
      }
    } else {
      console.log("[DBG] Iubenda API not available yet")
    }

    // Set up event listener for consent expression
    const handleConsentExpressed = () => {
      console.log("[DBG] consentSolutionExpressed event received")
      setConsentExpressed(true)
    }

    console.log("[DBG] Adding event listener for consentSolutionExpressed")
    document.addEventListener("consentSolutionExpressed", handleConsentExpressed)

    return () => {
      console.log("[DBG] Cleanup: removing consentSolutionExpressed event listener")
      document.removeEventListener("consentSolutionExpressed", handleConsentExpressed)
    }
  }, [])

  useEffect(() => {
    if (typeof window.dataLayer === "object" && consentExpressed) {
      console.log(`[DBG] Emitting casavo.pageview ${router.asPath} event:`, new Date().toISOString())
      dataLayerPush({
        event: "casavo.pageview",
        eventLabel: "PageView",
      })
    }
  }, [router.asPath, consentExpressed])

  return (
    <>
      <Head>
        <meta content="width=device-width, initial-scale=1" name="viewport" />
      </Head>

      <Component {...pageProps} err={err} />
    </>
  )
}

const __Page_Next_Translate__ = CustomApp


// @ts-ignore
    export default __appWithI18n(__Page_Next_Translate__, {
// @ts-ignore
      ...__i18nConfig,
// @ts-ignore
      isLoader: true,
// @ts-ignore
      skipInitialProps: true,
// @ts-ignore
      
// @ts-ignore
    });
// @ts-ignore
  